import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "./components/Sidebar";

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Users fetch karne ka function
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await API.get("/user/list.php");
      if (res.data.status === "success") {
        setUsers(res.data.users);
      } else {
        setUsers([]);
      }
      setLoading(false);
    } catch (err) {
      console.error("Failed to fetch users", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // User delete karne ka function
  const handleDelete = async (userId, userName) => {
    if (window.confirm(`Are you sure you want to delete ${userName}? This action cannot be undone.`)) {
      try {
        const res = await API.post("/user/delete.php", { id: userId });
        if (res.data.status === "success") {
          alert("User deleted successfully!");
          // UI se turant hata do bina page reload kiye
          setUsers(users.filter(user => user.id !== userId));
        } else {
          alert("Failed to delete user: " + res.data.message);
        }
      } catch (err) {
        alert("Error deleting user.");
      }
    }
  };

  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-content">
        <div className="aura-users-container" style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
          
          <div className="aura-users-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
            <div>
              <h2 style={{ fontSize: "24px", color: "#333", margin: "0 0 5px 0" }}>Manage Users</h2>
              <p style={{ margin: 0, color: "#666" }}>View and manage all registered customers.</p>
            </div>
            <div style={{ background: "#f0f4f8", padding: "10px 20px", borderRadius: "8px", fontWeight: "bold", color: "#007bff" }}>
              Total Users: {users.length}
            </div>
          </div>

          <div className="aura-users-card" style={{ background: "#fff", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", overflow: "hidden" }}>
            {loading ? (
              <div style={{ padding: "40px", textAlign: "center", color: "#666" }}>Loading users...</div>
            ) : users.length === 0 ? (
              <div style={{ padding: "40px", textAlign: "center", color: "#999" }}>No users found in the database.</div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
                  <thead style={{ background: "#f8f9fa", borderBottom: "2px solid #eee" }}>
                    <tr>
                      <th style={{ padding: "15px", color: "#444" }}>Name</th>
                      <th style={{ padding: "15px", color: "#444" }}>Contact Info</th>
                      <th style={{ padding: "15px", color: "#444" }}>Address Details</th>
                      <th style={{ padding: "15px", color: "#444", textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user.id} style={{ borderBottom: "1px solid #eee", transition: "0.2s" }} className="aura-table-row">
                        
                        <td style={{ padding: "15px" }}>
                          <strong style={{ display: "block", color: "#333" }}>{user.name}</strong>
                          <span style={{ fontSize: "12px", color: "#888" }}>ID: #{user.id}</span>
                        </td>
                        
                        <td style={{ padding: "15px" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "4px", fontSize: "14px" }}>
                            <span style={{ color: "#555" }}>📧 {user.email}</span>
                            <span style={{ color: "#555" }}>📱 {user.phone || "N/A"}</span>
                          </div>
                        </td>
                        
                        <td style={{ padding: "15px" }}>
                          <div style={{ fontSize: "14px", color: "#555", maxWidth: "250px" }}>
                            {user.address ? (
                              <>
                                <div>{user.address}</div>
                                <div style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
                                  {user.city}, {user.state} - {user.pincode}
                                </div>
                              </>
                            ) : (
                              <span style={{ color: "#999", fontStyle: "italic" }}>No address provided</span>
                            )}
                          </div>
                        </td>

                        <td style={{ padding: "15px", textAlign: "center" }}>
                          <button 
                            onClick={() => handleDelete(user.id, user.name)}
                            style={{
                              background: "#ff4d4f",
                              color: "white",
                              border: "none",
                              padding: "8px 16px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              fontWeight: "bold",
                              transition: "0.2s",
                            }}
                            onMouseOver={(e) => e.target.style.background = "#d9363e"}
                            onMouseOut={(e) => e.target.style.background = "#ff4d4f"}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}